import { Flex, Text, useTheme } from '@chakra-ui/react';
import { css } from '@emotion/react/macro';
import styled from '@emotion/styled/macro';
import React from 'react';
import { CheckCircle, X, XCircle } from 'components/Icons/Icons';
import { mq } from 'styles/breakpoints';
import { rem } from 'utils/fonts';

type Variant = 'success' | 'error';

const Wrapper = styled(Flex)<{ variant: Variant }>`
  width: 100%;
  padding: 20px;
  position: relative;
  border-radius: 12px;
  ${mq.md} {
    width: 419px;
  }
`;

const baseIconStyle = css`
  min-width: 25px;
  min-height: 25px;
  margin-top: 3px;
`;

const SuccessIcon = styled(CheckCircle)`
  ${baseIconStyle}
`;
const ErrorIcon = styled(XCircle)`
  ${baseIconStyle}
`;

const CloseIcon = styled(X)`
  position: absolute;
  top: 10px;
  right: 10px;
  min-height: 25px;
  min-width: 25px;
  cursor: pointer;
`;

export const ToastTitle = styled(Text)`
  font-weight: 600;
  font-style: normal;
  font-size: ${rem('18px')};
  line-height: 29px;
`;

export const ToastDescription = styled(Text)`
  font-style: normal;
  font-weight: normal;
  font-size: ${rem('18px')};
  line-height: 20px;
`;

interface Props {
  variant: 'success' | 'error';
  id: string | number;
  onClose: () => void;
}
const Toast: React.FC<Props> = ({ variant, children, onClose, id }) => {
  const { colors } = useTheme();
  return (
    <Wrapper
      key={id}
      variant={variant}
      mb="20px"
      mr={['0', '0', '35px']}
      mt="35px"
      color={variant === 'success' ? colors.gray[900] : colors.white}
      bg={variant === 'success' ? colors.other.toastSuccess : colors.other.toastError}
    >
      {variant === 'success' ? <SuccessIcon color={colors.gray[900]} /> : <ErrorIcon color={colors.white} />}
      <Flex ml="15px" direction="column" justifyContent="flex-start" alignItems="flex-start">
        {children}
      </Flex>
      <CloseIcon onClick={onClose} color={variant === 'success' ? colors.gray[900] : colors.white} />
    </Wrapper>
  );
};

export default Toast;
